package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class GetMerchantLocationsResponseModel(
    val locations: List<MerchantLocationResponseModel> = emptyList(),
    /** LocationId (as string key in JSON) -> full rating details for dialog and breakdown. */
    val ratingsByLocation: Map<String, LocationRatingResponseModel> = emptyMap()
) : BaseResponseModel()
